const penceToPound = (pence: number, rounded: boolean = true): string => {
  const numericValue = Number(pence);

  if (isNaN(numericValue)) return rounded ? '0' : '0.00';

  const value = numericValue / 100;
  return rounded ? Math.round(value).toString() : value.toFixed(2);
};

export default penceToPound;
